import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import DashboardPage from "../src/pages/DashboardPage";
import AppRoutes from "./routers/Routes";
import Navbar from "../src/components/Navbar";
import Footer from "../src/components/Footer";
import theme from "./theme";

//Custom Auth
import { AuthProvider } from "./components/auth/AuthContext";
import AuthenticatedApp from "./components/auth/AuthenticatedApp";

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <AuthenticatedApp>
        <Router>
          <Box 
            sx={{ 
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'background.default'
            }}
          >
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/*" element={<AppRoutes />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </AuthenticatedApp>
    </AuthProvider>
  </ThemeProvider>
);

export default App;


